$(function(){
  $('.alert--close').click(function(){
    $('.alert').remove()
  })
})
